import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              按主题发现你感兴趣的内容，找到属于你的影视品位
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {topics.map((topic, idx) => (
              <a
                key={idx}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-center justify-between bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 cursor-pointer"
              >
                <div className="flex items-center gap-3 min-w-0">
                  {topic.hot && (
                    <span className="inline-block px-1.5 py-0.5 rounded bg-primary-500 text-background-50 text-[10px] font-bold flex-shrink-0">
                      HOT
                    </span>
                  )}
                  <span className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {topic.name}
                  </span>
                </div>
                <span className="text-xs text-foreground-400 flex-shrink-0 ml-2">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}